import { useAuthStore } from "@/store/auth";
import usersRoute from "./users";
import roleRoute from "./role";
import zonalEOS from "./zonalEOS";
import lgaEOS from "./lgaEOS";
// import beceRoutes from "./beceRoutes";
import schoolRep from "./schoolRep";
import zonesRoute from "./zonesRoute";
import lgaRoute from "./lgaRoute";
// import qeRoutes from "./qeRoutes.js";
import stateRoute from "./stateRoute.js";
import beceRoutes from "./bece";
import qeRoutes from "./qe";
import baice from "./baice";
import saiqeRoute from "./saiqe";
export default [
  // ...qeRoutes,
  ...baice,
  ...usersRoute,
  ...roleRoute,
  ...zonalEOS,
  ...lgaEOS,
  ...lgaRoute,
  ...zonesRoute,
  // ...beceRoutes,
  ...schoolRep,
  ...stateRoute,
  //
  ...beceRoutes,
  ...qeRoutes,
  ...saiqeRoute,
  {
    path: "/",
    name: "login",
    component: () => import("@/views/auth/login.vue"),
    meta: {
      title: "Login",
      // beforeResolve(routeTo, routeFrom, next) {
      //   if (useAuthStore().isLoggedIn) {
      //     // Redirect to the home page instead
      //     next({ name: "default" });
      //   } else {
      //     next();
      //   }
      // },
    },
  },

  {
    path: "/TiHnJu",
    name: "Register",
    component: () => import("@/views/auth/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/Hyu9lD6Iv",
    name: "Forgot password",
    component: () => import("@/views/auth/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/wRX3URPZSq",
    name: "reset-password",
    component: () => import("@/views/auth/reset-password.vue"),
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
  },
  {
    path: "/vRhALtY5",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("@/views/dashboard/default.vue"),
  },
  {
    path: "/MEq9PY/:srt?/:ref?",
    name: "certificate",
    meta: {
      title: "Certificate",
    },
    component: () => import("@/views/verify/index.vue"),
  },
  {
    path: "/KoUdLEkHOU",
    name: "invalid-certificate",
    meta: {
      title: "Invalid Certificate",
    },
    component: () => import("@/views/verify/invalid.vue"),
  },
  {
    path: "/X1yj0RpcK8",
    name: "default1",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   next({ name: "dashboard" });
      //   // Continue to the login page
      // },
    },
    component: () => import("@/views/dashboard/default-02.vue"),
  },

  {
    path: "/mbCuAj",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   next({ name: "dashboard" });
      //   // Continue to the login page
      // },
    },
    component: () => import("@/views/dashboard/default.vue"),
  },
  {
    path: "/SnAGXN6E3",
    name: "menu",
    meta: {
      title: "Menu Content",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("@/views/settings/menu-list"),
  },

  {
    path: "/lfMfKoNtq6RK7WYutXmI",
    children: [
      {
        path: "years",
        name: "years",
        component: () => import("@/views/years/index.vue"),
        meta: {
          title: "Years",
          authRequired: true,
          acc: ["y100qw267"],
        },
      },
    ],
  },
  {
    path: "/ngihfnefywu09nrr8wrr",
    name: "appInfo",
    meta: {
      title: "Update Application Information",
      authRequired: true,
      acc: ["y100qw267"],
    },
    component: () => import("@/views/settings/appInfo/new.vue"),
  },
  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // start of import
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // end of import
];
